// App imports.
import { IGrantee, IUserInfo, IFiscalYear } from "../baseWorker";
import FiscalYears from "./components/FiscalYears";
import * as utility from "./utility";
import {
  IFieldCategory
  , IFieldSubCategory
  , IField
  , IGranteeWithSelectedField
  , IFiscalYearWithSelectedField
  , IReportResults
  , IReportResultColumn
  , IReportByIdResults
} from "./utility";

export class GraphType {
  code: string;
  name: string;
  graphTypeSelected: boolean;
  graphTypeAvailable: boolean;
  highChartsGraphType: string;
  highChartsStackingType: string;
  constructor(code: string
    , name: string
    , graphTypeAvailable: boolean
    , highChartsGraphType: string
    , highChartsStackingType: string) {
    this.name = name;
    this.code = code;
    this.graphTypeSelected = false;
    this.graphTypeAvailable = graphTypeAvailable;
    this.highChartsGraphType = highChartsGraphType;
    this.highChartsStackingType = highChartsStackingType;
  }
}
export enum AppPagesEnum {
  CreateReport = 0,
  DisplayReport = 1,
}

/**
 * This function must be called once and only once from BaseLayout.
 */
export function createState(inParentComponent) {
  return {
    //----------------------------------------------------------------------------------------------
    // Variables
    //----------------------------------------------------------------------------------------------
    ErrorMessage: '',
    HeaderText: 'LIHEAP Data Warehouse',
    ShowSpinner: false,
    UserInfo: {
      granteeId: -1,
      regionId: -1,
      viewAll: false,
      loggedIn: false
    },
    GraphTypes: {
      bar: new GraphType("bar", "Bar", false, "column", ""),
      map: new GraphType("map", "Map", false, "map", ""),
      multiBar: new GraphType("multiBar", "Multiple bars", false, "column", ""),
      stackedBar: new GraphType("stackedBar", "Stacked bar", false, "column", "normal"),
      stackedBarPercent: new GraphType("stackedBarPercent", "Stacked bar percent", false, "column", "percent"),
      combo: new GraphType("combo", "Combo", false, "column", ""),
      line: new GraphType("line", "Line", false, "line", ""),
      pie: new GraphType("pie", "Pie", false, "pie", ""),
      table: new GraphType("table", "Data table only", true, "", "")
    },

    Grantees: [],
    AllGranteesSelected: null,
    //SelectedGranteeIds: [],
    FiscalYears: [],
    Fields: [],
    SelectedCategoryId: null,
    SelectedFieldSubcategories: [],
    SelectedSubCategoryId: null,
    ReportTitle: "",
    ReportSubTitle: "",
    ReportDescription: "",
    CurrentPage: null,
    ReportData: null,

    displayReportById: async function (): Promise<void> {
      //get report id, years and grantees from querstring if passed
      const searchParams = new URLSearchParams(document.location.search);
      let reportId = searchParams.get("reportId");
      const granteesQueryStringParam = searchParams.get("grantees");
      const yearsQueryStringParam = searchParams.get("years");
      //if report id is passed, get report data and display it
      if (reportId && granteesQueryStringParam && yearsQueryStringParam) {
        const reportWorker: utility.ReportWorker = new utility.ReportWorker();
        let reportData: IReportByIdResults|null = null;
        try {
          reportData =
            await reportWorker.getReportDataById(Number(reportId)
              , granteesQueryStringParam
              , yearsQueryStringParam);


          //set fields selected
          let selectedReportFieldIds: number[] = reportData.columnInfo.map(col => col.fieldId);
          let fields = Object.assign([], this.state.Fields);
          fields.forEach(f => {
            if (selectedReportFieldIds.includes(f.tableFieldId))
              f.tableFieldSelected = true;
            else
              f.tableFieldSelected = false;
          });
          //set years selected
          let fiscalYears = Object.assign([], this.state.FiscalYears);
          fiscalYears.forEach(y => {
            if (yearsQueryStringParam.indexOf(y.fiscalYear) > -1) {
              y.fiscalYearSelected = true;
            }
          });
          
          //set grantees selected
          let grantees = Object.assign([], this.state.Grantees);
            
          
          //if this is a map, select all state grantees
          if(reportData.graphType == "Map")
          {
            grantees.forEach(g => {
                g.granteeSelected = true;
            });
          }
          else{
            grantees.forEach(g => {
              //put bars around grantees in querystring to make sure we don't get partial matches
              if (`|${granteesQueryStringParam}|`.indexOf(`|${g.granteeId.toString()}|`) > -1) {
                g.granteeSelected = true;
              }
            });
          } 


          //set graph type
          let graphTypes = Object.assign({}, this.state.GraphTypes);
          switch (reportData.graphType) {
            case "Bar":
              graphTypes.bar.graphTypeSelected = true;
              break;
            case "Map":
              graphTypes.map.graphTypeSelected = true;
              break;
            case "Multiple bars":
              graphTypes.multiBar.graphTypeSelected = true;
              break;
            case "Stacked bar":
              graphTypes.stackedBar.graphTypeSelected = true;
              break;
            case "Stacked bar percent":
              graphTypes.stackedBarPercent.graphTypeSelected = true;
              break;
            case "Combo":
              graphTypes.combo.graphTypeSelected = true;
              break;
            case "Line":
              graphTypes.line.graphTypeSelected = true;
              break;
            case "Pie":
              graphTypes.pie.graphTypeSelected = true;
              break;
            case "Data table only":
              graphTypes.table.graphTypeSelected = true;
              break;
          }
          this.setState({
            ReportData: reportData
            , CurrentPage: AppPagesEnum.DisplayReport
            , ReportTitle: reportData.reportTitle
            , ReportSubTitle: reportData.reportSubTitle
            , ReportDescription: reportData.reportDescription
            , FiscalYears: fiscalYears
            , Grantees: grantees
            , Fields: fields
            , GraphTypes: graphTypes
            , ShowSpinner: false
          });
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          throw Error(err.message);
        }
      }
      else {
        this.setState({
          CurrentPage: AppPagesEnum.CreateReport
          , ShowSpinner: false
        });

      }
    }.bind(inParentComponent),

    displayReport: async function (): Promise<void> {
      const reportWorker: utility.ReportWorker = new utility.ReportWorker();
      let reportData: IReportResults = null;
      try {
        
        reportData =
          await reportWorker.getReportData(
            this.state.Fields.filter(f => f.tableFieldSelected)
            , this.state.Grantees
            , this.state.FiscalYears);
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        throw Error(err.message);
      }

      this.setState({
        ReportData: reportData,
        CurrentPage: AppPagesEnum.DisplayReport
      });
    }.bind(inParentComponent),
    customizeReport: async function (): Promise<void> {
      this.setState({
        CurrentPage: AppPagesEnum.CreateReport
      });
    }.bind(inParentComponent),
    backToReportSelection: async function (): Promise<void> {
      throw Error("Not implemented");
      //this.setState({
      //  CurrentPage: AppPagesEnum.CreateReport
      //});
    }.bind(inParentComponent),
    displayReportDisabled: function (fieldId: number): boolean {
      let yearsCount = this.state.FiscalYears.filter(y => y.fiscalYearSelected).length;
      let granteesCount = this.state.AllGranteesSelected ? 1 :
        this.state.Grantees
          .filter(g => g.granteeSelected).length;

      let fieldsCount = this.state.Fields.filter(f => f.tableFieldSelected).length;

      return yearsCount == 0 || granteesCount == 0 || fieldsCount == 0;
    }.bind(inParentComponent),
    setFieldSubCategories: function (inFields: IField[]): void {
      this.setState({
        Fields: inFields,
      });
    }.bind(inParentComponent),
    getFieldCategories: function (): IFieldCategory[] {
      let prevCategory: number = -1;
      let categories: IFieldCategory[] = [];
      for (let i = 0; i < this.state.Fields.length; i++) {
        if (prevCategory != this.state.Fields[i].categoryId) {
          categories.push(this.state.Fields[i]);
        }
        prevCategory = this.state.Fields[i].categoryId;
      }
      return categories;
    }.bind(inParentComponent),
    setSelectedSubCategoryId: function (event: any, selectedSubCategoryId: number): void {
      event.preventDefault();
      this.setState({
        SelectedSubCategoryId: selectedSubCategoryId,
      });
    }.bind(inParentComponent),
    toggleFieldSelected: function (fieldId: number): void {
      let fields = Object.assign([], this.state.Fields);
      fields
        .filter(f => f.tableFieldId == fieldId)
        .forEach(f => f.tableFieldSelected = !f.tableFieldSelected);
      this.setState({
        Fields: fields
      });

      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    deselectAllFields: function (): void {
      event.preventDefault();
      let fields = Object.assign([], this.state.Fields);
      fields
        .forEach(f => f.tableFieldSelected = false);
      this.setState({
        Fields: fields
      });
      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    toggleAllGranteesSelected: function (): void {
      const updatedAllGranteesSelected: boolean = !!!this.state.AllGranteesSelected;

      console.log("toggleAllGranteesSelected: " + updatedAllGranteesSelected);

      let grantees = Object.assign([], this.state.Grantees);
      grantees
        .forEach(g => g.granteeSelected = false);
      this.setState({
        Grantees: grantees,
        AllGranteesSelected: updatedAllGranteesSelected,
      });

      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    toggleGranteeSelected: function (granteeId: number): void {
      let grantees = Object.assign([], this.state.Grantees);
      grantees
        .filter(g => g.granteeId == granteeId)
        .forEach(g => g.granteeSelected = !g.granteeSelected);
      this.setState({
        Grantees: grantees,
        AllGranteesSelected: false
      });
      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    setSelectionAllGrantees: function (selected: boolean): void {
      event.preventDefault();
      let grantees = Object.assign([], this.state.Grantees);
      grantees
        .forEach(g => g.granteeSelected = selected);
      this.setState({
        AllGranteesSelected: false,
        Grantees: grantees
      });
      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    toggleFiscalYearSelected: function (fiscalYear: number): void {
      let fiscalYears = Object.assign([], this.state.FiscalYears);
      fiscalYears
        .filter(f => f.fiscalYear == fiscalYear)
        .forEach(f => f.fiscalYearSelected = !f.fiscalYearSelected);
      this.setState({
        FiscalYears: fiscalYears
      });
      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    selectedYearsIncludesIncomplete: function (): boolean {
      return this.state.FiscalYears.filter(f => f.final != true).length > 0;
    }.bind(inParentComponent),
    setSelectionAllFiscalYears: function (selected: boolean): void {
      event.preventDefault();
      let fiscalYears = Object.assign([], this.state.FiscalYears);
      fiscalYears
        .forEach(f => f.fiscalYearSelected = selected);
      this.setState({
        FiscalYears: fiscalYears
      });
      this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    setSelectedCategoryId: function (event: any, selectedCategoryId: number): void {
      event.preventDefault();

      let prevSubCategory: number = -1;
      let subCategories: IFieldSubCategory[] = [];
      for (var i = 0; i < this.state.Fields.length; i++) {
        if (prevSubCategory != this.state.Fields[i].subCategoryId
          && this.state.Fields[i].categoryId == selectedCategoryId) {
          let subCategory: IFieldSubCategory = {
            categoryId: this.state.Fields[i].categoryId
            , subCategoryId: this.state.Fields[i].subCategoryId
            , subCategoryName: this.state.Fields[i].subCategoryName
          }
          subCategories.push(subCategory);
        }
        prevSubCategory = this.state.Fields[i].subCategoryId;
      }

      this.setState({
        SelectedCategoryId: selectedCategoryId,
        SelectedFieldSubcategories: subCategories
      });

    }.bind(inParentComponent),
    selectGraphType: function (inGraphTypeCode: string): void {
      let graphTypes = Object.assign([], this.state.GraphTypes);
      graphTypes.bar.graphTypeselected = false;
      graphTypes.map.graphTypeselected = false;
      graphTypes.multiBar.graphTypeselected = false;
      graphTypes.stackedBar.graphTypeselected = false;
      graphTypes.stackedBarPercent.graphTypeselected = false;
      graphTypes.combo.graphTypeselected = false;
      graphTypes.line.graphTypeselected = false;
      graphTypes.pie.graphTypeselected = false;
      graphTypes.table.graphTypeselected = false;

      graphTypes[inGraphTypeCode].graphTypeSelected = true;
      this.setState({
        GraphTypes: graphTypes
      });
    }.bind(inParentComponent),
    setReportTitle: function (inEvent: any): void {
      event.preventDefault();
      this.setState({
        ReportTitle: inEvent.target.value,
      });
      //this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    setReportSubTitle: function (inEvent: any): void {
      event.preventDefault();
      this.setState({
        ReportSubTitle: inEvent.target.value,
      });
      //this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    setReportDescription: function (inEvent: any): void {
      event.preventDefault();
      this.setState({
        ReportDescription: inEvent.target.value,
      });
      //this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    setReportTitles: function (inEvent: any): void {
      event.preventDefault();
      this.setState({
        ReportTitle: "",
        ReportSubTitle: "",
        ReportDescription: "",
      });
      //this.state.getAvailableChartTypes();
    }.bind(inParentComponent),
    getAvailableChartTypes: function () {
      let yearsCount = this.state.FiscalYears.filter(y => y.fiscalYearSelected).length;
      let granteesCount = this.state.Grantees.filter(g => g.granteeSelected).length;
      let fieldsCount = this.state.Fields.filter(f => f.tableFieldSelected).length;
      let graphTypes = {
        bar: new GraphType("bar", "Bar", false, "column", ""),
        map: new GraphType("map", "Map", false, "map", ""),
        multiBar: new GraphType("multiBar", "Multiple bars", false, "column", ""),
        stackedBar: new GraphType("stackedBar", "Stacked bar", false, "column", "normal"),
        stackedBarPercent: new GraphType("stackedBarPercent", "Stacked bar percent", false, "column", "percent"),
        combo: new GraphType("combo", "Combo", false, "column", ""),
        line: new GraphType("line", "Line", false, "line", ""),
        pie: new GraphType("pie", "Pie", false, "pie", ""),
        table: new GraphType("table", "Data table only", true, "", "")
      };

      //--------------------------------------------------------------
      // Determine if fields includes percent or average columns
      //--------------------------------------------------------------
      //let preventSumAllGrantees = false;
      let allowPie = true;
      let allowStackedBar = true;
      let allowLineOrBar = true;
      let previousUnit = '';
      let previousPie = '';
      this.state.Fields.filter(f => f.tableFieldSelected).forEach((fieldDetail, f) => {
        if (fieldDetail.tableFieldAllowPieFlag == 'N'
          || (previousPie != '' && fieldDetail.tableFieldPieGroup != previousPie)) {
          allowPie = false;
        }
        if (fieldDetail.tableFieldAllowPieFlag == 'N'
          || (previousUnit != '' && fieldDetail.tableFieldUnit != previousUnit)) {
          allowStackedBar = false;
        }
        if (previousUnit != '' && fieldDetail.tableFieldUnit != previousUnit) {
          allowLineOrBar = false;
        }
        previousUnit = fieldDetail.tableFieldUnit;
        previousPie = fieldDetail.tableFieldPieGroup;
      });
      //--------------------------------------------------------------


      if (yearsCount == 0) {
        //grantee not specified
        if (granteesCount == 0) {
          //no field selected
          if (fieldsCount == 0) {
            //None - Not enough info       
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.line.graphTypeAvailable = true;
            graphTypes.bar.graphTypeAvailable = true;
          }
          //two fields selected
          else if (fieldsCount == 2) {
            graphTypes.combo.graphTypeAvailable = true;
            if (allowLineOrBar) {
              graphTypes.bar.graphTypeAvailable = true;
            }
          }
          //multiple fields selected
          else {
            if (allowLineOrBar) {
              graphTypes.bar.graphTypeAvailable = true;
            }
            else {
              graphTypes.table.graphTypeAvailable = true;
              graphTypes.table.graphTypeSelected = true;
            }
          }
        }
        //one grantee selected
        else if (granteesCount == 1) {
          //no field selected
          if (fieldsCount == 0) {
            //Y               None - Not enough info  
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.line.graphTypeAvailable = true;
            graphTypes.bar.graphTypeAvailable = true;

          }
          //two fields selected
          else if (fieldsCount == 2) {
            graphTypes.combo.graphTypeAvailable = true;
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;
              if (allowStackedBar) {
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;

              }

            }
          }
          //multiple fields selected
          else {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;
              if (allowStackedBar) {
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
            else {
              graphTypes.table.graphTypeAvailable = true;
              graphTypes.table.graphTypeSelected = true;
            }
          }
        }
        //multiple grantees
        else {
          //no field selected
          if (fieldsCount == 0) {

            //no graph types avail --- not enough info
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.multiBar.graphTypeAvailable = true;

            if (allowStackedBar) {
              graphTypes.stackedBar.graphTypeAvailable = true;
              graphTypes.stackedBarPercent.graphTypeAvailable = true;
              graphTypes.multiBar.graphTypeAvailable = true;
            }
          }
          //two fields selected
          else if (fieldsCount > 1) {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }

            }
            else {
              graphTypes.table.graphTypeAvailable = true;
              graphTypes.table.graphTypeSelected = true;
            }
          }
        }
      }
      //one year selected
      else if (yearsCount == 1) {

        //grantee not specified
        if (granteesCount == 0) {
          //no field selected
          if (fieldsCount == 0) {
            //Y None - Not enough info  
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.table.graphTypeAvailable = true;
          }
          //two fields selected
          else if (fieldsCount == 2) {
            if (allowLineOrBar) {
              graphTypes.bar.graphTypeAvailable = true;
            }
            if (allowPie) {
              graphTypes.pie.graphTypeAvailable = true;
            }
            graphTypes.table.graphTypeAvailable = true;

          }
          else {
            graphTypes.bar.graphTypeAvailable = true;
            if (allowPie) {
              graphTypes.pie.graphTypeAvailable = true;
            }
          }
        }
        //one grantee selected
        else if (granteesCount == 1) {
          //no field selected
          if (fieldsCount == 0) {
            //Y               None - Not enough info  
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.table.graphTypeAvailable = true;
            graphTypes.table.graphTypeSelected = true;

          }
          //two fields selected
          else if (fieldsCount == 2) {
            if (allowLineOrBar) {
              graphTypes.bar.graphTypeAvailable = true;
            }
            if (allowPie) {
              graphTypes.pie.graphTypeAvailable = true;
            }
            graphTypes.combo.graphTypeAvailable = true;
          }
          //
          else {
            //Y Bar, Pie(no calc values)
            if (allowLineOrBar) {
              graphTypes.bar.graphTypeAvailable = true;
            }
            if (allowPie) {
              graphTypes.pie.graphTypeAvailable = true;
            }
            if (allowStackedBar) {
              graphTypes.stackedBarPercent.graphTypeAvailable = true;
              graphTypes.stackedBar.graphTypeAvailable = true;
              graphTypes.multiBar.graphTypeAvailable = true;
            }
          }
        }
        //multiple grantees
        else {
          //no field selected
          if (fieldsCount == 0) {
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.bar.graphTypeAvailable = true;
            graphTypes.map.graphTypeAvailable = true;

          }
          //two fields selected
          else if (fieldsCount == 2) {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;
              if (allowPie) {
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
            graphTypes.combo.graphTypeAvailable = true;
          }
          //
          else {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
          }
        }
      }
      //More than one year
      else {
        //grantee not specified
        if (granteesCount == 0) {
          //no field selected
          if (fieldsCount == 0) {
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.line.graphTypeAvailable = true;
            graphTypes.bar.graphTypeAvailable = true;
          }
          //two fields selected
          else if (fieldsCount == 2) {
            graphTypes.combo.graphTypeAvailable = true;
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
          }
          //
          else {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
          }
        }
        //one grantee selected
        else if (granteesCount == 1) {
          //no field selected
          if (fieldsCount == 0) {
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.line.graphTypeAvailable = true;
            graphTypes.bar.graphTypeAvailable = true;
          }
          //two fields selected
          else if (fieldsCount == 2) {
            graphTypes.combo.graphTypeAvailable = true;
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
          }
          else {
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
            else {
              graphTypes.table.graphTypeAvailable = true;
              graphTypes.table.graphTypeSelected = true;
            }
          }
        }
        //multiple grantees
        else {
          //no field selected
          if (fieldsCount == 0) {
            //None - Not enough info  
          }
          //single field selected
          else if (fieldsCount == 1) {
            graphTypes.multiBar.graphTypeAvailable = true;
          }
          //two fields selected
          else if (fieldsCount > 1) {
            graphTypes.table.graphTypeAvailable = true;
            if (allowLineOrBar) {
              graphTypes.multiBar.graphTypeAvailable = true;

              if (allowStackedBar) {
                graphTypes.stackedBarPercent.graphTypeAvailable = true;
                graphTypes.stackedBar.graphTypeAvailable = true;
                graphTypes.multiBar.graphTypeAvailable = true;
              }
            }
            else {
              graphTypes.table.graphTypeSelected = true;
            }
          }
        }
      }

      this.setState({
        GraphTypes: graphTypes
      });

    }.bind(inParentComponent),
    setFiscalYears: function (inFiscalYears: IFiscalYear[]): void {
      let fiscalYears: IFiscalYearWithSelectedField[] = [];
      inFiscalYears.forEach(f => {
        fiscalYears.push({
          fiscalYear: f.fiscalYear
          , final: f.final
          , fiscalYearSelected: false
        });

      })
      this.setState({
        FiscalYears: fiscalYears,
      });
    }.bind(inParentComponent),
    getGranteeName: function (inGranteeId: number): string {
      let granteeName: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeName = granteeArray[0].granteeName;
      }
      return granteeName;
    }.bind(inParentComponent),
    setGrantees: function (inGrantees: IGrantee[]): void {
      let grantees: IGranteeWithSelectedField[] = [];
      inGrantees.forEach(g => {
        grantees.push({
          granteeAbbreviation: g.granteeAbbreviation
          , granteeId: g.granteeId
          , granteeName: g.granteeName
          , granteeSelected: false
          , regionId: g.regionId
        });
      })
      this.setState({
        Grantees: grantees,
      });
    }.bind(inParentComponent),
    showError: function (errorMessage: string) {
      this.setState({
        ShowSpinner: false,
        ErrorMessage: errorMessage,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    setCurrentUserInfo: function (inUser: IUserInfo): void {
      this.setState({
        ErrorMessage: '',
        UserInfo: inUser
        , SelectedGranteeId: inUser.granteeId
      });
    }.bind(inParentComponent),
    showSpinner: function () {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: true,
      });
    }.bind(inParentComponent),
    hideSpinner: function () {
      this.setState({
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    scrollToTop: function () {
      const yOffset = -100;
      const element = document.getElementById("app");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    isNullOrEmpty: function (inString: any): boolean {
      if (inString === '' || inString === null) {
        return true;
      }
      else {
        return false;
      }
    },
    print: function () {
      window.print();
    }.bind(inParentComponent),

    //----------------------------------------------------------------------------------------------
  };
} /* End createState(). */

